import { Box, Button, CloseButton, createOverlay, Dialog, Portal, Separator, Text } from '@chakra-ui/react'
import { ParsedPricingInfo } from 'utils/apiUtils/prices'
import { useTranslation } from 'react-i18next'
import PeriodInfoContent from './PeriodInfoContent'

type Props = {
  pricingInfo: ParsedPricingInfo
}

interface DialogProps {
  content?: React.ReactNode
}

const dialog = createOverlay<DialogProps>((props) => {
  const { content, ...rest } = props
  const { t } = useTranslation('common')
  return (
    <Dialog.Root {...rest}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner position="center">
          <Dialog.Content
            width="100%"
            maxWidth={{ base: '90%', lg: '500px' }}
            maxHeight={{ base: '90vh', lg: 'auto' }}
            overflowY="auto"
          >
            <Dialog.Header>
              <Box display="flex" flexDirection="column" paddingY={4}>
                <Dialog.Title>{t('priceBreakdown')}</Dialog.Title>
                <Text fontSize="sm" marginTop="10px" lineHeight="normal">
                  {t('pricingInfoDescription.pricingDescription')}
                </Text>
              </Box>
            </Dialog.Header>
            <Separator />
            <Dialog.Body spaceY="4" paddingY={10}>
              {content}
            </Dialog.Body>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="2xl" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
})

const PeriodsInfo = ({ pricingInfo }: Props) => {
  const { t } = useTranslation('common')

  return (
    <Box>
      <Box marginBottom={5}>
        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
          <Text fontWeight="bold" fontSize="md" marginBottom={2}>
            {t('pricingInfoDescription.pricingHeader')}
          </Text>
          <Button
            fontSize={{ base: 'xs', lg: 'sm' }}
            fontWeight="normal"
            color="white"
            backgroundColor="green.a200"
            padding={4}
            onClick={() =>
              dialog.open('a', {
                content: <PeriodInfoContent pricingInfo={pricingInfo} />,
              })
            }
          >
            {t('priceBreakdown')}
          </Button>
          <dialog.Viewport />
        </Box>
        <Text fontSize="sm">{t('pricingInfoDescription.pricingDescription')}</Text>
      </Box>
    </Box>
  )
}

export default PeriodsInfo
